DemandFulfillmentOverview

<template>
  <v-container class="balance-overview__content">
    
    <v-row class="balance-overview__row">
      <v-col cols="2"> </v-col>

      <v-col cols="1" class="balance-overview__headline">N (%)</v-col> 
      <v-col cols="1" class="balance-overview__headline">N (t)</v-col> 
      <v-col cols="1" class="balance-overview__headline">N (kg/ha)</v-col> 
      <v-col cols="1" class="balance-overview__headline">P (%)</v-col> 
      <v-col cols="1" class="balance-overview__headline">P (t)</v-col> 
      <v-col cols="1" class="balance-overview__headline">P (kg/ha)</v-col> 
      <v-col cols="1" class="balance-overview__headline">K (%)</v-col> 
      <v-col cols="1" class="balance-overview__headline">K (t)</v-col> 
      <v-col cols="1" class="balance-overview__headline">K (kg/ha)</v-col> 
      <v-col cols="1"></v-col>
    
    </v-row>

    <v-row class="balance-overview__row demand-fulfillment__extended-row">
      <v-col cols="2" class="balance-overview__row-text">
          <span>{{ $t('demandFulfillmentOverview.rowBalance') }}</span>
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['N'].surplus_pct"
          :precision="1"
          chip
          :chipColor="chipColorForPercentage(balance['N'].surplus_pct)"
          showZero
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
           :value="balance['N'].surplus"
          chip
          showZero
          showPlus
          :scale="0.001"
          :chipColor="chipColorForPercentage(balance['N'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['N'].surplus_per_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(balance['N'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
         :value="balance['P'].surplus_pct"
          :threshold="0.005"
          :precision="1"
          chip
          :chipColor="chipColorForPercentage(balance['P'].surplus_pct)"
          showZero
        /> </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].surplus"
          chip
          showZero
          showPlus
          :scale="0.001"
          :chipColor="chipColorForPercentage(balance['P'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['P'].surplus_per_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(balance['P'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="balance['K'].surplus_pct"
          :precision="1"
          chip
          :chipColor="chipColorForPercentage(balance['K'].surplus_pct)"
          showZero
        />
       </v-col>
      <v-col cols="1">
        <formatted-value
         :value="balance['K'].surplus"
          chip
          showZero
          showPlus
          :scale="0.001"
          :chipColor="chipColorForPercentage(balance['K'].surplus_pct)"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
         :value="balance['K'].surplus_per_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(balance['K'].surplus_pct)"
        />
      </v-col>

      <v-col cols="1"> </v-col>
    </v-row>

    <hr class="balance__row-divider" />

    <v-row class="balance-overview__row">
      <v-col cols="2" class="balance-overview__row-text">
        <span>{{ $t('demandFulfillmentOverview.rowFertilizer') }}</span>
      </v-col>

      <v-col cols="1">
      </v-col>

      <v-col cols="1"
        ><formatted-value
          :value="project.demand_fulfillment.scenario.N.total_extern_fertilizer_t"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.N.total_extern_fertilizer_kg_ha"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1">
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.P.total_extern_fertilizer_t"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.P.total_extern_fertilizer_kg_ha"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1">
      </v-col>

      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.K.total_extern_fertilizer_t"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>
      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.K.total_extern_fertilizer_kg_ha"
          chip
          showZero
          :threshold="1"
          chipColor="grey"
        />
      </v-col>

      <v-col cols="1"> </v-col>
    </v-row>

    <hr class="balance__row-divider" />
     <v-row class="balance-overview__row">
      <v-col cols="2" class="balance-overview__row-text">

        <span>{{ $t('demandFulfillmentOverview.rowFulfillment') }}</span>
       
      </v-col>

      <v-col cols="1"
        >
        <formatted-value
          :value="project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_pct"
          chip
          showZero
          :precision="1"
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_pct)"
        />
      </v-col>

      <v-col cols="1"
        ><formatted-value
          :value="project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_t"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_pct)"
        />
      </v-col>
      
      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_kg_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_pct)"
        />
      </v-col>
      
       <v-col cols="1"
        >
        <formatted-value
          :value="project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_pct"
          chip
          showZero
          :precision="1"
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_pct)"
        />
      </v-col>

      <v-col cols="1"
        ><formatted-value
          :value="project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_t"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_pct)"
        />
      </v-col>
      
      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_kg_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_pct)"
        />
      </v-col>
       <v-col cols="1"
        >
        <formatted-value
          :value="project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_pct"
          chip
          showZero
          :precision="1"
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_pct)"
        />
      </v-col>

      <v-col cols="1"
        ><formatted-value
          :value="project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_t"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_pct)"
        />
      </v-col>
      
      <v-col cols="1">
        <formatted-value
          :value="project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_kg_ha"
          chip
          showZero
          showPlus
          :chipColor="chipColorForPercentage(project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_pct)"
        />
      </v-col>

      <v-col cols="1"> </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import FormattedValue from "./FormattedValue.vue";

export default {
  name: "DemandFulfillmentSummary",

  components: {
    FormattedValue,
  },

  computed: {
    ...mapGetters(["balance"]),
    ...mapState(['project']), 
  },
  methods: {
    chipColorForPercentage (value, tolerance=10) {
      if (!value) {
        return '';
      }
      return Math.abs(100 - value) <= tolerance ? 'green' : 'red'
    }
  }
  
};
</script>
